<template>
    <modal @close="modeResetRaDom">
        <template slot="header_title">
            Supprimer le composant
        </template>
        <template slot="main">
            <div class="main_story_delete_component">
                <strong>Voulez-vous vraiment supprimer ce composant ?</strong>
                <br>Vous perdrez l'ensemble des données saisies.
                <br>Impossible d’annuler cette opération.
            </div>
        </template>
        <template slot="footer">
            <v-layout row wrap>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_red" @click="modeResetRaDom">
                        <i class="fas fa-times fa-btn" />
                        <span v-if="!isMobile">Annuler</span>
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_blue"
                           @click="localRaDomDeleteComponent">
                        <i class="fas fa-check fa-btn" />
                        <span v-if="!isMobile">Valider</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </template>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'RaDomDeleteComponent',
        components: {
            modal: () => import('../../global/modal')
        },
        props: {
            indexRaDomComponent: {
                type: Number,
                default: -1
            }
        },
        computed: {
            ...mapGetters('app', ['isMobile'])
        },
        methods: {
            ...mapActions('actions/raDom', ['raDomDeleteComponent', 'modeResetRaDom']),
            ...mapActions('app', ['showOverlay', 'hideOverlay']),
            localRaDomDeleteComponent: function () {
                let _this = this;
                this.showOverlay();
                this.raDomDeleteComponent().then(() => {
                    _this.hideOverlay();
                    _this.$emit('close');
                }).catch((err) => {
                    this.$toasted.error(err);
                    _this.hideOverlay();
                    _this.$emit('cancel');
                });
            }
        }
    };
</script>

<style scoped>
    .main_story_delete_component {
        padding: 20px;
        text-align: center;
    }
</style>
